<template>
  <div class="summary-transformer-info">
    <div class="pr-2">
      <div class="my-1">
        <strong class="mr-2">{{ companyRegionalLabel }}</strong>
        <span>{{ companyRegionalValue || '-' }}</span>
      </div>
      <div class="my-1">
        <strong class="mr-2">{{ $t('fields.asset.transformer.nominal-potency') }}</strong>
        <s-input-label-edit
            v-model="infos.nominalPotency"
            :formatted-value="formatNumberValue(infos.nominalPotency, 2)"
            :editable="false"
        >
          <s-number-input
              v-model="infos.nominalPotency"
              class="text-right"
          />
        </s-input-label-edit>
      </div>
    </div>
    <div class="pr-2">
      <div class="my-1">
        <strong class="mr-2">{{ $t('entities.installation') }}</strong>
        <span>{{ infos.installation || '-' }}</span>
      </div>
      <div class="my-1">
        <strong class="mr-2">{{ $t('fields.asset.transformer.higher-voltage') }}</strong>
        <s-input-label-edit
          v-model="infos.superiorVoltage"
          :formatted-value="formatNumberValue(infos.superiorVoltage, 2)"
          :editable="false"
        >
          <s-number-input
            v-model="infos.superiorVoltage"
            class="text-right"
          />
        </s-input-label-edit>
      </div>
    </div>
    <div class="pr-2">
      <div class="my-1">
        <strong class="mr-2">{{ $t('asset-information.asset-info.asset-identification') }}</strong>
        <span>{{ infos.asset || '-' }}</span>
      </div>
      <div class="my-1">
        <strong class="mr-2">{{ $t('fields.asset.transformer.lower-voltage') }}</strong>
        <s-input-label-edit
          v-model="infos.inferiorVoltage"
          :formatted-value="formatNumberValue(infos.inferiorVoltage, 2)"
          :editable="false"
        >
          <s-number-input
            v-model="infos.inferiorVoltage"
            class="text-right"
          />
        </s-input-label-edit>
      </div>
    </div>
    <div class="pr-2">
      <div class="my-1">
        <strong class="mr-2">{{ $t('asset-information.asset-info.serial-number') }}</strong>
        <span>{{ infos.serialNumber || '-' }}</span>
      </div>
      <div class="my-1">
        <strong class="mr-2">{{ $t('fields.asset.transformer.tertiary-voltage') }}</strong>
        <s-input-label-edit
          v-model="infos.tertiaryVoltage"
          :formatted-value="formatNumberValue(infos.tertiaryVoltage, 2)"
          :editable="false"
        >
          <s-number-input
            v-model="infos.tertiaryVoltage"
            class="text-right"
          />
        </s-input-label-edit>
      </div>
    </div>
  </div>
</template>

<script>
import SummaryInfosService from '@/domain/services/installation/assetInfo/summaryInfos';

export default {
  name: 'SummaryTransformerInfo',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    infos: {},
  }),
  computed: {
    companyRegionalLabel() {
      const withRegional = `${this.$t('entities.company')}/${this.$t('entities.regional')}`;
      const withoutRegional = `${this.$t('entities.company')}`;
      return this.infos.regional ? withRegional : withoutRegional;
    },
    companyRegionalValue() {
      const withRegional = `${this.infos.company}/${this.infos.regional}`;
      let withoutRegional;
      if (this.infos.company) {
        withoutRegional = `${this.infos.company}`;
      }
      return this.infos.regional ? withRegional : withoutRegional;
    },
  },
  created() {
    this.callTransformerInfos();
  },
  methods: {
    formatNumberValue(value, decimais = 0) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, {
        minimumFractionDigits: decimais,
        maximumFractionDigits: decimais,
      });
    },
    callTransformerInfos() {
      const { assetId } = this.$route.params;
      this.$emit('update:loading', true);
      SummaryInfosService.getTransformerSummaryInfos(assetId)
        .then((response) => {
          this.infos = response;
        }).finally(() => {
          this.$emit('update:loading', false);
        });
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .summary-transformer-info
    border: 1px solid $color-border-gray
    border-radius: 5px
    padding: 5px 20px 2px
    display: flex
    flex-wrap: wrap
    justify-content: space-between
    > div
      display: inline-block
    ::v-deep
      .label-edit_viewing
        min-width: unset
        display: inline-flex
</style>
